import { Injectable } from "@angular/core";
import { ISectionPresenter } from '../../../models/section-presenter';
import { FeatureToggleService } from '../../../../services/feature-toggle/feature-toggle.service';
import { DeviceSettingsFeatureToggle } from "src/app/enums/feature-toggle.enum";
import { IntelligentSecurityService } from "src/app/services/smart-assist/intelligent-security/intelligent-security.service";
import { IntelligentSecurityAIOService } from "src/app/services/smart-assist/intelligent-security-AIO/intelligent-security-AIO.service";

@Injectable({
	providedIn: 'root'
})

export class IntelligentSecuritySection implements ISectionPresenter {
	constructor(
		private featureToggleService: FeatureToggleService,
		private intelligentSecurityService: IntelligentSecurityService,
		private intelligentSecurityServiceAIO: IntelligentSecurityAIOService,
	) { }

	public async isVisible(): Promise<boolean> {
		const isIntelligentSecurityAvailable = await this.intelligentSecurityService.isAvailable();
		const isFeatureToggleEnabled = this.featureToggleService.isDeviceSettingsFeatureAvailable(
			DeviceSettingsFeatureToggle.SmartAssistIntelligentSecurity
		);

		return isFeatureToggleEnabled && isIntelligentSecurityAvailable;
	}

	public async isAIOVisible(): Promise<boolean> {
		const isIntelligentSecurityAIOAvailable = await this.intelligentSecurityServiceAIO.getHPDCapability();
		const isFeatureToggleEnabled = await this.featureToggleService.getAdPolicyByName(
			"feature."+DeviceSettingsFeatureToggle.DeviceSettings+"."+DeviceSettingsFeatureToggle.SmartAssistIntelligentSecurity
		);
		const isPageEnabled = await this.featureToggleService.getAdPolicyByName(
			"page.smartAssist"
		);

		return isFeatureToggleEnabled && isIntelligentSecurityAIOAvailable && isPageEnabled ;
	}
}
